<template>
  <img src="../../../assets/img/avatars/avatar10.jpg" alt="avatar10">
</template>
